import {
  Button,
  EmptyState,
  Heading,
  NoDataIcon,
  NotStartedIcon,
} from '@lmc/ui-kit'
import styled from 'styled-components'
import dayjs from 'dayjs'
import StatusWidget from './components/StatusWidget'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import useTodayMonitoring from 'screens/Rostering/hooks/useTodayMonitoring'
import WarningsWidget from './components/WarningsWidget'
import AbsentWidget from './components/AbsentWidget'
import ClockedInWidget from './components/ClockedInWidget'
import CurrentlyClockedInWidget from './components/CurrentlyClockedInWidget'
import WaitingToClockInWidget from './components/WaitingToClockInWidget'

const TodayMonitoring = () => {
  const { t } = useTranslation()

  const { todayMonitoring } = useTodayMonitoring()

  if (!todayMonitoring) return null

  const noPatterns = !todayMonitoring.hasRotaPatterns
  const noData = todayMonitoring.statusSummary?.total === 0

  return (
    <Container>
      <DateContainer>
        <Date level={2}> {dayjs().format('Do MMMM YYYY')} </Date>
      </DateContainer>
      {noPatterns && (
        <EmptyState
          icon={<NotStartedIcon />}
          title={t('EMPTY_STATE_NOT_STARTED_TITLE')}
          description={t('EMPTY_STATE_ADD_ROTA_PATTERNS')}
        >
          <Link to={`${window.location.origin}/rota/patterns`} target="_blank">
            <Button variant="primary">{t('ADD_ROTA_PATTERNS')}</Button>
          </Link>
        </EmptyState>
      )}

      {noData && !noPatterns && (
        <EmptyState
          icon={<NoDataIcon />}
          title={t('EMPTY_STATE_NO_DATA')}
          description={t('EMPTY_STATE_NO_EVENTS')}
        />
      )}
      {!noPatterns && !noData && (
        <WidgetsContainer>
          <ColumnContainer>
            <TopRowContainer>
              <StatusWidget todayMonitoring={todayMonitoring} />
              <WarningsWidget todayMonitoring={todayMonitoring} />
              <RightColumnContainer>
                <ClockedInWidget
                  clockedIn={todayMonitoring.clockedInMembers?.length}
                  total={todayMonitoring.totalExpectedClockedIns}
                />
                <AbsentWidget users={todayMonitoring.absentMembers} />
              </RightColumnContainer>
            </TopRowContainer>
            <RowContainer>
              <CurrentlyClockedInWidget
                clockedIns={todayMonitoring.clockedInMembers}
              />
              <WaitingToClockInWidget
                clockedIns={todayMonitoring.pendingClockIns}
              />
            </RowContainer>
          </ColumnContainer>
        </WidgetsContainer>
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 24px;
  color: ${(props) => props.theme.color.neutral.color3};
`

const Date = styled(Heading)`
  margin-left: 24px;
`

const WidgetsContainer = styled.div`
  width: 100%;
`

const TopRowContainer = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
`

const RightColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  min-width: 0;
`

const RowContainer = styled.div`
  display: flex;
  gap: 24px;
`
const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const DateContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
`

export default TodayMonitoring
